import User from './user';
import formatters from '../../utils/periods.formatters';
import { AvailableDay } from './availableDayTypes';

class vacationsAbsencesUser extends User {
  constructor(userId, profile) {
    super(userId, profile);
    this.absenceTypes = [];
    this.vacationTypes = [];
    this.vacationPeriods = [];
    this.absencePeriods = [];
    this.nationalHolidays = [];
    this.localHolidays = [];
    this.holidays = [];
    this.allPeriods = [];
    this.availableVacations = [];
    this.periodInDays = [];
    this.maternityPaternityLeavePeriods = [];
  }

  addPeriod(period) {
    this.allPeriods.push(period);
    this._periodInDays = formatters.formatPeriodInDays(this.allPeriods);
    return this._periodInDays;
  }

  getAgreementVacationCount() {
    return this.vacationPeriods.filter((periode) => {
      return periode.availableDayType === AvailableDay.TYPES.AGREEMENT;
    }).length;
  }

  getPeriodById(periodId) {
    return this.allPeriods[periodId];
  }

}

export default vacationsAbsencesUser;



// WEBPACK FOOTER //
// ./client/app/common/domain/models/vacationsAbsencesUser.js